import React from 'react';
import './storeOnlyMobileDrawer.scss';
import { DrawerNav } from '@thd-olt-component-react/drawer';

const StoreOnlyInfoMobileDrawer = () => (
  <div className="StoreOnlyMobileDrawer__wrapper">
    <DrawerNav backLinkTxt="">
      <span className="StoreOnlyMobileDrawer__header">Not Eligible for Order Pickup</span>
    </DrawerNav>
    <div className="StoreOnlyMobileDrawer__divider" />
    <span className="StoreOnlyMobileDrawer__body">
      While this item is in stock at a store near you, it is not eligible for Order Pickup. Visit
      your local Home Depot to purchase in store.&nbsp;
    </span>
  </div>
);

export { StoreOnlyInfoMobileDrawer };
